import { readonly, ref } from 'vue';

const queryHistory = ref(new Map());

export function useQueryHistory() {
  const setQuery = (routeName, query) => {
    queryHistory.value.set(routeName, { ...query });
  };

  const getQuery = (routeName) => {
    return queryHistory.value.get(routeName) || {};
  };

  const clearQuery = (routeName) => {
    queryHistory.value.delete(routeName);
  };

  const clearAll = () => {
    queryHistory.value.clear();
  };

  // const getQueryKey = (route) => {
  //   // Enables preserving subroute query params by adding the unique id to the name.
  //   const nestedKey = route.meta.preserveNestedKey && route.params?.[route.meta.preserveNestedKey];

  //   if (nestedKey) return `${route.name}-${nestedKey}`;

  //   return route.name;
  // };

  return {
    clearAll,
    clearQuery,
    getQuery,
    queryHistory: readonly(queryHistory),
    setQuery,
  };
}
